import { Page_Pagebuilder_Blocks_Iframe } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const IframeBlock = ({
  blockId,
  containerWidth,
  title,
  url,
  editor,
}: Page_Pagebuilder_Blocks_Iframe) => {
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className={`w-full ${getContainerClass(containerWidth)}`}
      >
        <div className="grid md:grid-cols-2 gap-8 editor px-4 md:px-0">
          <div className="@container editor">
            {title && <h2 className="mb-5 lg:mb-10">{title}</h2>}
            {url && (
              <iframe
                src={url}
                className="w-full border border-neutral-200 h-[600px]"
              ></iframe>
            )}
          </div>
          {editor && (
            <div className="editor">
              <Wysiwyg customViewport={{ once: false, margin: '0px' }}>
                {editor}
              </Wysiwyg>
            </div>
          )}
        </div>
      </m.div>
    </section>
  );
};

export default IframeBlock;
